import React, { useContext, useState } from "react"
import classnames from "classnames/bind"
import { Calendar as CalIcon, Clock } from "react-feather"
import { format } from 'date-fns'
import Calendar from "react-calendar"
import TimePicker from "react-time-picker"
import { CartContext } from "src/context/CartContext"
import ModalLayout from './ModalLayout'
import { ModalContext } from "src/context/ModalContext"
import { Button } from "src/components/core/atoms/button"

import * as styles from "./modal.module.css"
import "./timePicker.css"
import "./calendar.css"
import { set } from "date-fns"

export const AddTiming = ( props ) => {
  const { closeModal } = useContext( ModalContext )
  const { dispatchDateTimes, ACTIONS } = useContext( CartContext )
  const [ dateValue, onDateChange ] = useState( new Date() )
  const [ timeValue, onTimeChange ] = useState( "10:00" )
  const [ isDefault, setIsDefault ] = useState( props.isDefault )

  const cx = classnames.bind( styles )

  const handleAdd = ( dateValue, timeValue ) => {
    const [ hour, minute ] = timeValue.split( ':' )
    const date = set( dateValue, { hours: parseInt( hour ), minutes: parseInt( minute ) } )
    console.log( { date } )
    dispatchDateTimes( { type: ACTIONS.DATETIME_ADD, payload: { date, isDefault } } )
    closeModal()
  }

  return (
    <ModalLayout>
      <div className={ styles.addTiming }>
        <header>
          <h1>Add Date & Time</h1>
        </header>
        <div className={ styles.innerCalendarContainer }>
          <div className={ cx( 'timeBox' ) }>
            <span>
              <CalIcon />{ " " }{ format( dateValue, 'dd.MM.yyyy' ) }
            </span>
            <span>
              <Clock />
              <TimePicker
                onChange={ onTimeChange }
                value={ timeValue }
                disableClock={ true }
                className={ "react-time-picker" }
                amPmAriaLabel={ "Select AM/PM" }
              />
            </span>
          </div>
          <Calendar
            onChange={ onDateChange }
            value={ dateValue }
            className={ "react-calendar" }
            locale="en-GB"
            minDetail="year"
            minDate={ new Date() }
            maxDate={ new Date( ( new Date().getFullYear() + 5 ) + "-" + ( new Date().getMonth() ) + "-" + ( new Date().getDate() ) ) }
          />
        </div>
        <div className={ styles.checkBoxContainer }>
          <input
            type="checkbox"
            name="isDefault"
            checked={ isDefault }
            onChange={ () => setIsDefault( !isDefault ) }
          />
          <label htmlFor="isDefault">
            Apply as default <b>date & time</b> for all services?
          </label>
        </div>
        <Button
          variant="solid"
          onClick={ () => {
            handleAdd( dateValue, timeValue )
          } }
        >
          Add Times
        </Button>
      </div>
    </ModalLayout>
  )
}
export default AddTiming
